<template>
  <div id="paginaBolle">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Elenco Bolle</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id="dropAnniRiferimento" ref="dropAnniRiferimento" :query="queryAnno"
                  :dataSource="annoRiferimentoList" :index="annoIndex" :fields="annoRiferimentoFields"
                  :change="onAnnoRiferimentoChange" v-model="annoRiferimentoCorrente"
                  placeholder="Seleziona un Anno"></ejs-dropdownlist>
              </b-col>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                  @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-alert variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown" height="4px" />
                </b-alert>
              </b-col>

              <b-col xl="12" md="12" class="pt-1">
                <ejs-grid id="gridA" ref="gridA" :dataSource="bolleFullData" :allowSorting="true"
                  :sortSettings="gridA.sortOptions" :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions"
                  :height="gridA.height" :allowFiltering="true" :filterSettings="gridA.filterOptions"
                  :editSettings="gridA.editOptions">
                  <e-columns>
                    <e-column field="id" headerText="ID" :isPrimaryKey="true" width="10"></e-column>
                    <e-column field="data" headerText="Data" :format="settings.formatoData" type="date"
                      width="30"></e-column>
                    <e-column field="causale" headerText="Causale" width="40"></e-column>
                    <e-column field="trasporto" headerText="Trasporto" width="30"></e-column>
                    <e-column field="aspetto" headerText="Aspetto" width="30"></e-column>
                    <e-column field="num_colli" headerText="Num Colli" width="30"></e-column>
                    <e-column field="peso" headerText="Peso" width="20"></e-column>
                    <e-column field="fornitore" headerText="Fornitore" foreignKeyField="id"
                      foreignKeyValue="ragioneSociale" :dataSource="fornitoriList" width="60"></e-column>
                  </e-columns>
                </ejs-grid>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- dialogA: dialogDettaglioBolla ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog id="dialogA" ref="dialogA" :header="dialogA.header" :buttons="dialogA.buttons" :visible="dialogA.visible"
      :showCloseIcon="dialogA.showCloseIcon" :close="dialogAClose" :open="dialogAOpen" :zIndex="dialogA.zIndex"
      :animationSettings="dialogA.animationSettings" :isModal="dialogA.isModal">
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA" v-model="dialogA.tabAdialogAIndex">
        <b-tab title="Dati Bolla">
          <b-row class="match-height">
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dati Bolla</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="id" class="h5">Id</label>
                      <ejs-textbox id="id" v-model="bolleActiveData.id" floatLabelType="Never" cssClass=""
                        placeholder="id" showClearButton="true" type="text" autocomplete="false" :readonly="true" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="data" class="h5">Data</label>
                      <ejs-datepicker id="data" v-model="bolleActiveData.data"
                        :format="settings.formatoDatepicker" placeholder="Data"
                        :firstDayOfWeek="settings.firstDayOfWeek"/>
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="causale" class="h5">Causale</label>
                      <ejs-textbox id="causale" v-model="bolleActiveData.causale" placeholder="Causale" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="trasporto" class="h5">Trasporto</label>
                      <ejs-textbox id="trasporto" v-model="bolleActiveData.trasporto" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="aspetto" class="h5">Aspetto</label>
                      <ejs-textbox id="aspetto" v-model="bolleActiveData.aspetto" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="num_colli" class="h5">Num Colli</label>
                      <ejs-textbox id="num_colli" v-model="bolleActiveData.num_colli" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="peso" class="h5">Peso</label>
                      <ejs-textbox id="peso" v-model="bolleActiveData.peso" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="fornitore" class="h5">Fornitore</label>
                      <ejs-dropdownlist
                        id="fornitore" ref="fornitore"
                        v-model="bolleActiveData.fornitore"
                        :dataSource="fornitoriList" :fields="fornitoriFields"
                        :allowFiltering="true" :filtering="fornitoriFiltering"
                        :itemTemplate="itemTemplate" :valueTemplate="valueTemplate"
                        placeholder="Scegli fornitore"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="porto" class="h5">Porto</label>
                      <ejs-textbox id="porto" v-model="bolleActiveData.porto" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="corriere" class="h5">Corriere</label>
                      <ejs-textbox id="corriere" v-model="bolleActiveData.corriere" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>

                    <b-col xl="12" md="12" class="pt-1">
                      <ejs-grid id="gridD" ref="gridD" :dataSource="elementiBollaFullData" :allowSorting="true"
                        :toolbar="gridD.toolbarOptions" :height="gridD.height" :toolbarClick="gridDClickHandler"
                        :allowFiltering="true" :filterSettings="gridD.filterOptions" :editSettings="gridD.editOptions"
                       >
                        <e-columns>
                          <e-column field="id" headerText="ID" :isPrimaryKey="true" width="30" :visible="false"></e-column>
                          <e-column field="qta" headerText="Q.ta" width="30"></e-column>
                          <e-column field="unita_misura" headerText="Unita' misura" width="30"></e-column>
                          <e-column field="codice" headerText="Codice" width="40"></e-column>
                          <e-column field="descrizione" headerText="Descrizione" width="100"></e-column>
                        </e-columns>
                      </ejs-grid>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

    <ejs-dialog
      id="dialogB"
      ref="dialogB"
      :header="dialogB.header"
      :buttons="dialogB.buttons"
      :visible="dialogB.visible"
      :showCloseIcon="dialogB.showCloseIcon"
      :close="dialogBClose"
      :open="dialogBOpen"
      :zIndex="dialogB.zIndex"
      :animationSettings="dialogB.animationSettings"
      :height="dialogB.height"
      :width="dialogB.width"
      :isModal="dialogB.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogB" v-model="dialogB.tabAdialogBIndex">
        <b-tab title="Dettaglio elemento">
          <b-row class="match-height">
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Elemento Bolla</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body DDD -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="qta" class="h5">Quantita</label>
                      <ejs-numerictextbox
                        id="qta" v-model="elementiBollaActiveData.qta"
                        floatLabelType="Never" cssClass="" placeholder="Qta"
                        showSpinButton="false" showClearButton="true"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="unita_misura" class="h5">Unita' di misura</label>
                      <ejs-textbox id="unita_misura" v-model="elementiBollaActiveData.unita_misura" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false" />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="codice" class="h5">Codice</label>
                      <ejs-textbox id="codice" v-model="elementiBollaActiveData.codice" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false" />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="descrizione" class="h5">Descrizione</label>
                      <ejs-textbox id="descrizione" v-model="elementiBollaActiveData.descrizione" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false" />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="costo_singolo" class="h5">Costo singolo</label>
                      <ejs-numerictextbox
                        id="costo_singolo" v-model="elementiBollaActiveData.costo_singolo"
                        floatLabelType="Never" cssClass="" format="€ ###" showSpinButton="false" showClearButton="true"
                        :change="onCostoSingoloChange"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="costo_totale" class="h5">Costo totale</label>
                      <ejs-numerictextbox
                        id="costo_totale" v-model="elementiBollaActiveData.costo_totale"
                        floatLabelType="Never" cssClass="" format="€ ###" showSpinButton="false" showClearButton="true"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  ImagePlugin,
  LinkPlugin,
  AlertPlugin,
  ToastPlugin,
} from "bootstrap-vue";
// import Vuexy

// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api

const apiFornitoriUrl = "/demo/api/soggetto/fornitori";
const apiBolleUrl = "/demo/api/bolla";
const apiBolleGeneraUrl = "/demo/api/bolla/genera";
const apiBolleAnnoUrl = "/demo/api/bolla/anno";
const apiElementiBollaCreateUrl = "/demo/api/elementobolla/bulk_create";
const apiElementoBollaCreateSingoloUrl = "/demo/api/elementobolla";
const apiElementiBollaUrl = "/demo/api/elementobolla";

var itemVue = Vue.component("itemTemplate", {
  template: `<span><span class='ragioneSociale'>{{data.ragioneSociale}}</span><span style='margin-right:3em;display:inline-block;'>&nbsp;&nbsp;</span><span class ='partitaIva'>{{data.partitaIva}}</span></span>`,
  data() {
    return {
      data: {},
    };
  },
});

export default Vue.extend({
  components: {},
  data() {
    return {
      dataOggi: new Date(),
      // tmp
      nonMostrare: false, // utile per non cancellare codice in editing
      // generali
      settings: {
        formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
        formatoOra: { skeleton: "Hm" },
        //formatoOra: 'HH:mm',
        formatoOraGrid: { type: "dateTime", format: "HH:mm" }, // da usare per grid
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        intervalloOra: 5,
        firstDayOfWeek: 1,
      },
      bolleFullData: [],
      bolleActiveId: 0,
      bolleActiveData: {},
      elementiBollaFullData: [],
      elementiBollaActiveData: {},
      elementiBollaActiveId: 0,

      // per inizializzazione dropdown a null
      initIndex: -1,
      //fornitori
      fornitoriList: [],
      fornitoriFields: { text: "ragioneSociale", value: "id" },
      //spettacoli
      spettacoliFullData: [],
      elencoSpettacoliFields: { value: "id", text: "titolo" },
      spettacoliIndex: -1,
      // tipo pagamento
      tipoList: [
        { label: "Bonifico", val: "bonifico" },
        { label: "Emolumento", val: "emolumento" },
      ],
      tipoFields: { text: "label", value: "val" },

      itemTemplate: function () {
        return { template: itemVue };
      },
      valueTemplate: function () {
        return { template: itemVue };
      },

      annoRiferimentoList: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      annoRiferimentoFields: { value: "val", text: "label" },
      annoIndex: -1,
      queryAnno: null,
      querySpettacoli: null,
      annoRiferimentoCorrente: new Date().getFullYear().toString(),
      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA
      dialogA: {
        header: "",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogAOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogACancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogAIndex: 0,
        isModal: false,
      },

      // per dialog B
      dialogB: {
        header: "Elemento bolla",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogBOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogBCancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1060,
        tabAdialogBIndex: 0,
        height: "90%",
        width: "90%",
        isModal: true,
      },

      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuova Bolla",
            tooltipText: "Crea nuova bolla",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Modifica",
            tooltipText: "Modifica bolla",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Cancella",
            tooltipText: "Cancella bolla",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          {
            text: "Download",
            tooltipText: "Download",
            prefixIcon: "e-save",
            id: "download",
          },
          "Search",
        ],
        sortOptions: { columns: [{ field: "data", direction: "Ascending" }] },
      },
      // per gridD
      gridDFlag: false,
      gridD: {
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuovo elemento",
            tooltipText: "Aggiungi nuovo elemento",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Cancella",
            tooltipText: "Cancella elemento",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          "Search",
        ],
      }, //
    };
  },
  created() {
    console.log("Pagina Bolle Creata");
    // inizializzazione elenchi dal backend
    // chiamate API

    if (localStorage.getItem("userData") !== null) {
      console.log("Recupero elenco Bolle dal backend");
      // fornitori
      useJwt.get(apiFornitoriUrl).then((d) => {
        if (d.status != 200) {
          console.log("REDIRIGERE A LOGIN");
          alert("Effettua di nuovo il login");
        } else {
          // console.log(d.status);
          // console.log(d.data);
          this.fornitoriList = d.data;
        }
      });

      const datiDaInviare = { anno: this.annoRiferimentoCorrente, };
      useJwt.post(apiBolleAnnoUrl, datiDaInviare).then((d) => {
        console.log("Bolle")
        console.log(d.data);
        this.bolleFullData = d.data;
      });
      // recupera spettacoli anno

    } else {
      console.log("Non trovo UserData, prova ancora");
    }
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey],
    // per multiselect
    multiselect: [CheckBoxSelection],
  },
  methods: {
    fornitoriFiltering: function (e) {
      var searchData = this.fornitoriList;
      var query = new Query();
      query = e.text != "" ? query.where("ragioneSociale", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    spettacoloFiltering: function (e) {
      var searchData = this.spettacoliFullData;
      var query = new Query();
      query =
        e.text != "" ? query.where("titolo", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    onAnnoRiferimentoChange: function (e) {
      console.log("Change")
      console.log("Recupero elenco bolle per l'anno selezionato");
      const datiDaInviare = { anno: this.annoRiferimentoCorrente, };
      useJwt.post(apiBolleAnnoUrl, datiDaInviare).then((d) => {
        console.log("Bolle")
        console.log(d.data);
        this.bolleFullData = d.data;
      });
    },

    onCostoSingoloChange: function (e) {
      this.elementiBollaActiveData.costo_totale = this.elementiBollaActiveData.costo_singolo * this.elementiBollaActiveData.qta
    },
    onFornitoreChange: function (e) {
      console.log("Cambio fornitore")
      console.log(this.$refs.fornitore.ej2Instances.value)
      const id_fornitore = this.$refs.fornitore.ej2Instances.value
      // adesso devo cercare nella lista fornitori per ID
      // filter 

      const i = this.fornitoriList.findIndex((x) => x.id === id_fornitore)
      if (i >= 0) {
        const t = this.fornitoriList[i] // ho il fornitore
        this.elementiBollaActiveData.ragioneSociale = t.ragioneSociale
        console.log(this.elementiBollaActiveData)
      } else {
        console.log("non trovato")
      }
    },
    // per dialogA
    dialogAOpen(args) {
      console.log("Apertura dialogA");
    
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogAClose() {
      console.log("Chiusura dialogA");
      this.dialogA.tabAdialogAIndex = 0;
      //console.log(this.bolleActiveData);
    },
    async dialogAOk() {
      let error = false
      console.log("Cliccato bottone OK di dialogA");
      // salvataggio informazioni in remoto
      if (this.bolleActiveId === 0) {
        // salvataggio in caso di new
        error = await useJwt.post(apiBolleUrl, this.bolleActiveData)
          .then((res) => {
            this.bolleActiveId = res.data.id;
            return this; // restituisci contesto per permettere aggiornamento grid
          })
          .then((context) => {
            // faccio post di tutti gli elementi e li salvo uno ad uno lato server
            const datiDaInviare = {
              'bolla_id': this.bolleActiveId,
              'elementi': this.elementiBollaFullData,
            }
            console.log("elementi bolla")
            console.log(datiDaInviare)
            useJwt.post(apiElementiBollaCreateUrl, datiDaInviare).then((res) => {
              if (res.status == 200 || res.status == 201) {
                console.log(res.data)
              }
              // TODO: gestione errore
            });
            return context
          })
          .then((context) => {
            const datiDaInviare = { anno: context.annoRiferimentoCorrente, };
            useJwt.post(apiBolleAnnoUrl, datiDaInviare).then((res) => {
              console.log("Aggiornamento gridA dopo aggiunta bolla");
              context.bolleFullData = res.data;
              context.bolleFullData = [...context.bolleFullData];
              console.log(context.bolleFullData)
            })

            return false
          }).catch(error => {
            let messaggio = ""
            if (error.response) {
              //console.log(error.response.data)
              let chiavi = Object.keys(error.response.data)
              chiavi.forEach((k) => {
                messaggio += `${k}: ${error.response.data[k]}`
                messaggio += "\n"
              })
              console.log(messaggio)
              this.makeToast("primary", "ERRORE", messaggio);
            }
            return true
          })
          if (!error) {
            // nascondi dialog solo se creazione avvenuta con successo
            this.$refs.dialogA.hide();
          }

      } else {
        // salvataggio in caso di edit
        const editUrl = `${apiBolleUrl}/${this.bolleActiveId}`;

        error = await useJwt.patch(editUrl, this.bolleActiveData)
          .then((res) => {
            console.log("salvataggio bolla OK")
            return this
          }).then((context) => {
              const datiDaInviare = { anno: context.annoRiferimentoCorrente, };
              useJwt.post(apiBolleAnnoUrl, datiDaInviare).then((d) => {
                console.log("Bolle")
                console.log(d.data);
                context.bolleFullData = d.data;
              });
              return false
            }).catch(error => {
            let messaggio = ""
            if (error.response) {
              console.log(error.response.data)
              let chiavi = Object.keys(error.response.data)
              chiavi.forEach((k) => {
                messaggio += `${k}: ${error.response.data[k]}`
                messaggio += "\n"
              })
              console.log(messaggio)
              this.makeToast("primary", "ERRORE", messaggio);
            }
            return true
          })
          if (!error) {
            this.$refs.dialogA.hide();
          }
      }
    },
    dialogACancel() {
      console.log("Cliccato bottone Cancel di dialogA");
      this.$refs.dialogA.hide();
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "new") {
        this.dialogA.header = "Nuova Bolla"
        const oggi = new Date
        this.bolleDefaultData = {
          id: 0,
          data: oggi,
          causale: null,
          trasporto: null,
          aspetto: null,
          num_colli: 0,
          peso: null,
          fornitore: null,
          porto: null,
          corriere: null,
        }
        this.bolleActiveData = this.bolleDefaultData
        console.log("Premuto pulsante creazione nuova bolla da gridA")
        // console.log(this.bolleActiveData);
        // console.log(this.praticheVVFDefaultData);
        this.bolleActiveId = 0
        this.elementiBollaFullData = []
        this.$refs.dialogA.show(true)
      }
      else if (args.item.id === "edit") {
        console.log("Premuto pulsante modifica bolla da gridA");
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          this.bolleActiveId = selectedRow[0].id
          console.log("gridA, Id selezionato:")
          console.log(this.bolleActiveId)
          const i = this.bolleFullData.findIndex(
            (x) => x.id === this.bolleActiveId
          )
          if (i >= 0) {
            this.bolleActiveData = this.bolleFullData[i]
            this.elementiBollaFullData = [...(this.bolleActiveData.elementi || [])]
            console.log(this.bolleActiveData)

            this.elementiBollaFullData.forEach((obj) => {
              const j = this.fornitoriList.findIndex((x) => x.id === obj.fornitore)
              if (j >= 0) {
                const t = this.fornitoriList[j] // ho il fornitore
                obj.ragioneSociale = t.ragioneSociale
              }
            })
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella")
          console.log(err)
          this.alertAShow()
        }

        this.$refs.dialogA.show(true)
      } else if (args.item.id === "delete") {
        try {
          console.log("Premuto pulsante elimina bolla da gridA")
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          const deletedElementId = selectedRow[0].id

          const deleteUrl = `${apiBolleUrl}/${deletedElementId}`
          this.$refs.gridA.ej2Instances.deleteRecord()
          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo")
            // console.log(res.data)
          })
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "download") {
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          const datiDaInviare = {'id': selectedRow[0].id, 'stagione': this.annoRiferimentoCorrente}
          useJwt.post(apiBolleGeneraUrl, datiDaInviare, { responseType: "blob" }).then((r) => {
            const contentDisposition = r.headers["content-disposition"]
            let nomeFile = `bolla_${selectedRow[0].id}.docx`
            if (contentDisposition && contentDisposition.includes("filename=")) {
              nomeFile = contentDisposition.split("filename=")[1].replace(/["']/g, "").trim()
            }

            const url = window.URL.createObjectURL(new Blob([r.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", nomeFile);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }).catch((err) => {
            console.log(err);
            this.makeToast("primary", "ERRORE", "Errore nella generazione del documento della bolla");
          })
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
    },
    // per dialogB
    dialogBOpen(args) {
      // CCC
      if (this.elementiBollaActiveId == 0) {
        this.elementiBollaActiveData = {
          'qta': 0,
          'unita_misura': '',
          'codice': '',
          'descrizione': '',
        }
      }
      console.log("Apertura dialogB");

      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogBClose() {
      console.log("Chiusura dialogB");
      this.dialogB.tabAdialogBIndex = 0;
    },
    dialogBOk() {
      console.log("Cliccato bottone OK di dialogB");
      if (this.elementiBollaActiveId == 0) {
        console.log("NEW elemento")
        // TODO: distinguere new da edit -> salvataggio in caso di edit
        // aggiungere record a tabella
        this.elementiBollaFullData.push(this.elementiBollaActiveData)
        this.elementiBollaFullData = [...this.elementiBollaFullData]
        if (this.bolleActiveId != 0) {
            console.log("crea singolo elemento")
            const datiDaInviare = {
              'bolla_id': this.bolleActiveId,
              'elemento': this.elementiBollaActiveData,
            }
            useJwt.post(apiElementoBollaCreateSingoloUrl, datiDaInviare).then((res) => {
              if (res.status == 200 || res.status == 201) {
                console.log(res.data)
              }
              // TODO: gestione errore
            });

        }
      } else {
        // fare patch
        console.log("edit elemento")

        const editUrl = `${apiElementiBollaUrl}/${this.elementiBollaActiveId}`;
        useJwt.patch(editUrl, this.elementiBollaActiveData)
              .then((res) => {
                if (res.status == 200 || res.status == 201) {
                  this.makeToast(
                    "primary",
                    "Successo",
                    "Modifica di un elemento bolla"
                  );
                }
                // TODO: trigger aggiornamento lista bolle

              })
      }
      this.$refs.dialogB.hide();
    },
    dialogBCancel() {
      console.log("Cliccato bottone Cancel di dialogB");
      this.$refs.dialogB.hide();
    },
    gridDClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "new") {
        // nuovo elemento
        this.elementiBollaActiveId = 0
        this.$refs.dialogB.show(true);
      } else if (args.item.id === "edit") {
        // edit
        try {
          const selectedRow = this.$refs.gridD.getSelectedRecords()
          this.elementiBollaActiveId = selectedRow[0].id
          // console.log("gridA, Id selezionato:")
          console.log(this.elementiBollaActiveId)
          const i = this.elementiBollaFullData.findIndex(
            (x) => x.id === this.elementiBollaActiveId
          )
          if (i >= 0) {
            this.elementiBollaActiveData = this.elementiBollaFullData[i]
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella")
          this.alertAShow()
        }
        this.$refs.dialogB.show(true);
      } else if (args.item.id === "delete") {
        // Pulsante DELETE
        // cancella elemento bolla
        try {
          console.log("Premuto pulsante elimina di gridD");
          this.$refs.gridD.ej2Instances.deleteRecord();

          const selectedRow = this.$refs.gridD.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;

          const deleteUrl = `${apiElementiBollaUrl}/${deletedElementId}`;
          this.$refs.gridA.ej2Instances.deleteRecord();

          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo");
            // console.log(res.data)
          });
          // ricalcola totale e aggiorna bolla
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// seleziono il colore per evidenziare la riga selezionata
.e-grid td.e-active {
  background-color: #e5cbdd;
}
</style>
